module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/affirm-payment-card-3775ea23d54363f059c483935e5bb47a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/affirm-payment-card.svg
// module id = uL0e
// module chunks = 24